let getSiteHeader = function(site) {
    let additionalHeaders = {};
    additionalHeaders.headers = {'Content-Type': 'application/json', 'x-homeaway-site': site};
    return additionalHeaders;
};

export {
    getSiteHeader
};
